import * as React from "react";
import { Button } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
import { useDispatchTrackEvent } from "@grandvisionhq/svc-tealium/events";
const FindAStoreCTA = ({ onNavigate, href, className }) => {
  const { getLabel } = useIntl();
  const dispatchTrackEvent = useDispatchTrackEvent();
  const findStoreOpenEvent = React.useCallback(
    () => Promise.resolve({
      id: "Impression",
      Page_Section2: "FisPdp",
      Events_FindStoreOpen: "1"
    }),
    []
  );
  const handleClick = React.useCallback(() => {
    dispatchTrackEvent(findStoreOpenEvent);
    onNavigate && onNavigate();
  }, [findStoreOpenEvent, onNavigate, dispatchTrackEvent]);
  const tealiumAttributes = {
    "data-element-id": "Prod_FindInStore"
  };
  if (!href) {
    return null;
  }
  return /* @__PURE__ */ React.createElement(
    Button,
    {
      className,
      href,
      "data-t": "btn-excluded-from-checkout",
      caption: getLabel("products.actions.excludedFromCheckout"),
      onClick: handleClick,
      ...tealiumAttributes
    }
  );
};
export {
  FindAStoreCTA
};
//# sourceMappingURL=FindAStoreCTA.js.map
